import { branch, renderNothing } from 'recompose';

export default branch(
  ({ showIf }) => !showIf,
  renderNothing,
);
